import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Box, TextField, InputLabel, MenuItem, FormControl, Select } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";

// import { useNavigate, useParams } from "react-router-dom";
import TopButton from './../../Components/UI/TopButtons';
import { joinByKeys } from "./../../Js/Common";
import { getFormatedDate } from "../../Js/TimeAndDate";
import { getUsersByRoleId } from "./Services";
import html2pdf from 'html2pdf.js';
import { find } from "lodash";
import { fetchProduct, productSliceActions } from "../../Store/Slices/ProductSlice";

const LearnersCertificates = () => {
    //Hooks
    const styles = useStyles();
    const dispatch = useDispatch();


    // Redux state
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
    const { paramsdata } = useSelector((state) => state.common);
    const { siteConfig } = useSelector((state) => state.defs);
    let coursePermissions = useSelector(
        (state) => state.defs.siteConfig.products[0]["coursePermissions"]
    );
    let { productData, language } = useSelector((state) => state.product);

    console.log("siteConfig====>", siteConfig)
    console.log("coursePermissions=====>", coursePermissions);
    console.log("productData, ====>,language=====>", productData, language);

    // Status
    const [selectedClassId, setSelectedClassId] = useState(null);
    const [userData, setUserData] = useState([]);
    const [allClasses, setAllClasses] = useState([]);
    const [isActive, setIsActive] = useState(false);

    const [assessmentYear, setAssessmentYear] = useState(null);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedCourseName, setSelectedCourseName] = useState(null);
    const [instituteName, setInstituteName] = useState(siteConfig.customer.customerName);

    const [isLoading, setIsLoading] = useState(true);
    const [product, setProduct] = useState({});
    const [languages, setLanguages] = useState([]);
    const [module, setModule] = useState([]);


    useEffect(() => {
        const getInitialData = async () => {
            dispatch(
                fetchProduct({
                    productId: siteConfig.products[0]["productId"],
                    productVersion: siteConfig.products[0]["productVersion"],
                })
            );
            setAllClasses(paramsdata.allClasses);
            let currentYear = getFormatedDate(new Date(), 'YYYY');
            let disYear = getFormatedDate(new Date(), 'YY');
            let assessYear = currentYear - 1;
            setAssessmentYear(`${assessYear}-${disYear}`);
        };
        getInitialData();
    }, []);

    useEffect(() => {
        let data = productData;
        // console.log("data====>", data);
        if (data) {
            if (typeof data == "string") {
                data = JSON.parse(data);
            }
            let courseObj;
            if (typeof data[0]["course_data"] == "string") {
                courseObj = JSON.parse(data[0]["course_data"]);
            } else {
                courseObj = product[0]["course_data"];
            }
            setProduct(courseObj["data"][0]["data"]);
            console.log("IIII", courseObj["data"][0]["data"]);
            if (!courseObj.data[0]?.data[0]?.data[0]?.data[0]?.data[0].isClass) {
                setLanguages(
                    courseObj["data"][0]["data"].filter((val) => {
                        return coursePermissions.indexOf(val.value) == -1;
                    })
                );
                if (language == -1) {
                    setModule(courseObj["data"][0]["data"][0]["data"]);
                    dispatch(productSliceActions.setLanguage(0));
                } else {
                    setModule(courseObj["data"][0]["data"][language]["data"]);
                }
            } else {
                setModule(courseObj["data"][0]["data"]);
            }
            setIsLoading(false);
        }
    }, [productData, coursePermissions]);

    useEffect(() => {
        console.log("module====>", module);
        if (module.length > 0) {
            handleChangeCourse(module[0])
        }
    }, [module]);

    useEffect(() => {
        if (selectedClassId != null) {
            fetchUsersByRole(selectedClassId);
        }
    }, [selectedClassId]);

    const changeLanguage = (index) => {
        dispatch(productSliceActions.setLanguage(index));
        console.log("product===>", product[index]["data"]);
        setModule(product[index]["data"]);
    };

    const handleChangeCourse = (itemData) => {
        setSelectedCourse(itemData.id);
        setSelectedCourseName(itemData.value);
    };

    const handleChangeInstitute = (event) => {
        //const { name, value } = event.target;
        //setUserData({ ...userData, [name]: value });
        setInstituteName(event.target.value);
    };


    const fetchUsersByRole = async (selectedClassId = null) => {
        let params = {
            query: {
                $select: ["uid", "name", "belongs_to"],
                role_uid: paramsdata.rolesData.uid,
                site_uuid: userInfo.site_uuid,
                belongs_to: selectedClassId,
                status: true,
                $limit: -1
            },
        };

        let resUsersData = await getUsersByRoleId(params);
        // console.log("resUsersData======>", resUsersData);
        // console.log("userInfo====>", userInfo);
        setUserData(resUsersData.data);
    };

    const standardName = (id) => {
        let foundObj = find(allClasses, { id: id });
        if (foundObj) {
            return foundObj.value;
        }
        return "NA";
    };

    const downloadPDF = () => {
        let element = document.getElementById('pdfid');
        let opt = {
            margin: 0,
            filename: `certificate_${standardName(selectedClassId)}.pdf`,
            jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' }
        };
        //html2pdf(element,opt);
        html2pdf().from(element).set(opt).toPdf().save();
    }

    return (
        <>
            <TopButton
                title={`Learners Certificates`}
                downloadIcon={userData.length > 0 ? true : false}
                pressTopBtn={downloadPDF}
                dropDownData={allClasses}
                fetchBySelectedValue={(classId) => { setSelectedClassId(classId) }}
                isActiveUsers={userData.length > 0 ? true : false}
                activeText={'Original'}
                defaultActiveUsers={false}
                pressParentIsActive={(val) => setIsActive(val)}
            />
            <Grid container sx={{
                flexDirection: "row",
                justifyContent: "flex-start",
                marginTop: '5px',
            }}>
                <Grid item>
                    <InputLabel sx={{
                        m: 1,
                        '@media (min-width: 1636px)': {
                            fontSize: '1.2rem',
                        }
                    }}>Enter Institute Name</InputLabel>
                    <TextField
                        size="small"
                        required
                        id="outlined-required"
                        sx={{
                            borderRadius: 50,
                        }}

                        InputProps={{
                            inputProps: {
                                sx: {
                                    color: "#DB8829",
                                    fontSize: "0.9rem",
                                    fontWeight: "500",
                                    width: "30ch",
                                    '@media (min-width: 1636px)': {
                                        fontSize: '1.4rem',
                                        width: "35ch"
                                    }

                                },
                            },
                            sx: { borderRadius: 50 },
                        }}
                        name={"instituteName"}
                        value={instituteName}
                        onChange={handleChangeInstitute}
                    // onBlur={() => { nameBlurValidate() }}
                    // error={nameError}
                    // helperText={nameError}
                    />
                </Grid>
                {languages && languages.length > 0 && (
                    <Grid item sx={{ paddingLeft: '10px' }}>
                        <InputLabel sx={{
                            m: 1,
                            '@media (min-width: 1636px)': {
                                fontSize: '1.2rem',
                            }
                        }}>Select Language</InputLabel>
                        <FormControl fullWidth size="small">
                            <Select
                                value={language}
                                sx={{
                                    borderRadius: 10,
                                    borderColor: "#DB8829",
                                    color: "#DB8829",
                                    fontWeight: "500",
                                    "@media (min-width: 1636px)": {
                                        fontSize: "1.4rem",
                                        mt: 0.5,
                                    },
                                }}
                            >
                                {languages.map((itemData, index) => (
                                    <MenuItem
                                        sx={{
                                            color: "#DB8829",
                                            fontSize: "0.8rem",
                                            fontWeight: "500",
                                            "@media (min-width: 1636px)": {
                                                fontSize: "1.2rem",
                                            },
                                        }}
                                        key={`${index}_Class`}
                                        value={index}
                                        onClick={() => {
                                            changeLanguage(index);
                                        }}
                                    >
                                        {itemData.value}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                )}
                {!isLoading &&
                    <Grid item sx={{ paddingLeft: '10px' }}>
                        <InputLabel sx={{
                            m: 1,
                            '@media (min-width: 1636px)': {
                                fontSize: '1.2rem',
                            }
                        }}>Courses</InputLabel>
                        <FormControl sx={{ minWidth: 120 }} size="small">
                            <Select
                                autoWidth
                                value={selectedCourse}
                                sx={{
                                    borderRadius: 10,
                                    borderColor: "#DB8829",
                                    color: "#DB8829",
                                    fontWeight: "500",
                                    "@media (min-width: 1636px)": {
                                        fontSize: "1.4rem",
                                        mt: 0.5,
                                    }
                                }}
                            >
                                {(module.length > 0) &&
                                    module.filter((val) => {
                                        return (
                                            coursePermissions &&
                                            coursePermissions.indexOf(val.value) == -1
                                        );
                                    }).map((itemData, ind) => {
                                        return (
                                            <MenuItem
                                                key={`${ind}_class`}
                                                value={itemData.id}
                                                onClick={() => { handleChangeCourse(itemData) }}
                                                sx={{
                                                    color: "#DB8829",
                                                    fontSize: "0.8rem",
                                                    fontWeight: "500",
                                                    "@media (min-width: 1636px)": {
                                                        fontSize: "1.2rem",
                                                    },
                                                }}>
                                                {itemData.value}
                                            </MenuItem>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                    </Grid>
                }
            </Grid>

            {userData && userData.length > 0 &&
                <Grid
                    container
                    spacing={0}
                    className={styles.scrollBar}
                    sx={{
                        height: "65vh",
                        overflow: "auto",
                        flexDirection: "row",
                        justifyContent: "space-around",
                        alignItems: "center",
                        marginTop: '20px',
                    }}
                >
                    <Box id="pdfid" >
                        {userData.map((objUser, index) => {
                            return (
                                <>
                                    {(index > 0) &&
                                        <div class="html2pdf__page-break"></div>
                                    }
                                    <table align="center" border="0" cellpadding="0" cellspacing="0" width="755"
                                        style={{ border: isActive ? '1px solid #CCC' : '0px solid', backgroundColor: isActive ? '#404F93' : ``, backgroundColor: isActive ? '#404F93' : '#FFF' }}>
                                        <tr>
                                            <td>
                                                <table align="center" border="0" cellpadding="0" cellspacing="0" width="755"
                                                    style={{ background: 'white', margin: '20px' }}>
                                                    <tr style={{ visibility: isActive ? 'visible' : 'hidden' }}>
                                                        <td align="center" className="font" colspan="2"
                                                            style={{ background: `linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,255,0) 3%,rgba(255,255,255,1) 4%,rgba(255,255,255,1) 96%,rgba(255,255,255,0) 97%,rgba(255,255,255,0) 100%)` }}>
                                                            <img src={require('../../assets/certi_logo.png')}
                                                                width="20%" style={{ marginTop: '45px' }} />
                                                        </td>
                                                    </tr>
                                                    <tr style={{ visibility: isActive ? 'visible' : 'hidden' }}>
                                                        <td colspan="2"
                                                            style={{ color: '#404F93', padding: '30px 50px 30px', textAlign: 'center', fontWeight: 'bolder', fontFamily: 'Montserrat', fontSize: '46px' }}>
                                                            <span style={{ color: '#E72C2D', fontSize: '68px' }}>CERTIFICATE</span><br />OF ACHIEVEMENT
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{height: '18em'}}>
                                                            <tr>
                                                                <td
                                                                    style={{ color: '#404F93', textAlign: 'center', lineHeight: '1.8', fontWeight: '500', fontFamily: 'Montserrat', fontSize: '20px', }}>
                                                                    <div style={{ display: 'inline-block' }}>
                                                                        <div style={{ display: 'inline-block' }}>This certificate is awarded to</div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <tr style={{ visibility: 'visible' }}>
                                                                <td
                                                                    style={{ color: '#404F93', textAlign: 'justify', padding: '12px 60px 0px', lineHeight: '1.8', fontWeight: '500', fontFamily: 'Montserrat', fontSize: '20px' }}>
                                                                    <div style={{ display: 'inline-block' }}>
                                                                        {/* <div style={{ display: 'inline-block' }}>This certificate is awarded to</div> */}
                                                                        <div
                                                                            style={{ borderBottom: '1px solid #404F96', fontWeight: '600', display: 'inline-block', width: '100%', textAlign: 'center' }}>
                                                                            {joinByKeys(
                                                                                objUser.name,
                                                                                ["firstname", "lastname"],
                                                                                " "
                                                                            )}</div>
                                                                        studying in&nbsp;
                                                                        <div style={{ borderBottom: '1px solid #404F96', fontWeight: '600', display: 'inline-block', width: '80%', textAlign: 'center', lineHeight: '1.8' }}>{standardName(selectedClassId)}
                                                                        </div> of&nbsp;
                                                                        <div
                                                                            style={{ borderBottom: '1px solid #404F96', fontWeight: '600', display: 'inline-block', width: '96%', textAlign: 'center', lineHeight: '1.8' }}>
                                                                            {instituteName}</div><br />
                                                                        in recognition of successful completion of&nbsp;
                                                                        <div style={{ borderBottom: '1px solid #404F96', fontWeight: '600', display: 'inline-block' }}>
                                                                            {selectedCourseName}
                                                                        </div> of the Vocablab English Language System during the academic year {assessmentYear}. Your hard work,
                                                                        determination, and commitment to academic excellence has
                                                                        enabled you to reach this significant milestone, and we are
                                                                        proud to recognize your achievement.
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </td>
                                                    </tr>

                                                    <tr
                                                        style={{ backgroundImage: `url('/logoback.png')`, backgroundSize: '110%', backgroundRepeat: 'no-repeat', visibility: isActive ? 'visible' : 'hidden' }}>
                                                        <td style={{ padding: '25px 0px 0px' }}>
                                                            <table width="100%" style={{ textAlign: 'center' }}>
                                                                <tr>
                                                                    <td width="100%" style={{ padding: '50px', position: 'relative', textAlign: '-webkit-center' }}>
                                                                        <table>
                                                                            <tr>
                                                                                <td colspan="2"
                                                                                    style={{ color: '#404F93', fontWeight: 'bolder', lineHeight: '1.4', fontFamily: 'Montserrat', fontSize: '22px', borderBottom: '1px solid #404F96', width: '180%', textAlign: 'center', paddingTop: '25px' }}>
                                                                                    <img src={require('../../assets/signature.png')} width="40%" />
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td colspan="2"
                                                                                    style={{ color: '#404F93', lineHeight: '1.4', fontFamily: 'Montserrat', fontSize: '16px', textAlign: 'center' }}>
                                                                                    <b>Mr. Jasvinder Singh</b><br />
                                                                                    <b>CEO</b><br />
                                                                                    www.wordsworthelt.com
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                </>
                            )
                        })}
                    </Box>
                </Grid>
            }
        </>
    );
};
const useStyles = makeStyles({
    scrollBar: {
        "&::-webkit-scrollbar": {
            width: "0.6em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        },
    },
});

export default LearnersCertificates;
